// GENERATED from app/services/nectar/page_blocks.rb — DO NOT EDIT.
// Run bin/generate-nectar-page-blocks to regenerate.

export const NectarPageBlock = {
  CommunityJoinModal: 'community_join_modal',
  CommunityUpgradeModal: 'community_upgrade_modal',
  CommunityChannelUpgradeModal: 'community_channel_upgrade_modal',
  CommunityFeed: 'community_feed',
  CommunitySpaceFeed: 'community_space_feed',
  CommunityPostPage: 'community_post_page',
  CommunityFeedUpgradeBanner: 'community_feed_upgrade_banner',
  CommunityFeedUpgradeButton: 'community_feed_upgrade_button',
  CommunityFeedGatedPosts: 'community_feed_gated_posts',
  CommunityFeedGatedPostsUpgradeButton: 'community_feed_gated_posts_upgrade_button',
  CommunityJoinRefused: 'community_join_refused',
  CommunitySearchModal: 'community_search_modal',
  CommunityMemberDirectoryFilterOnline: 'community_member_directory_filter_online',
  CommunityMemberDirectoryFilterNearby: 'community_member_directory_filter_nearby',
  CommunityMemberDirectoryFilterAll: 'community_member_directory_filter_all',
  CommunityMemberDirectorySortNewest: 'community_member_directory_sort_newest',
  CommunityMemberDirectorySortName: 'community_member_directory_sort_name',
  CommunityJoinBanner: 'community_join_banner',
  CommunitySidebarSearch: 'community_sidebar_search',
  CommunitySidebarChannel: 'community_sidebar_channel',
  CommunityFeedFollowingTab: 'community_feed_following_tab',
  CommunityMemberEditProfile: 'community_member_edit_profile',
  CommunityMemberSettingsBilling: 'community_member_settings_billing',
  CommunityMobileAppCallout: 'community_mobile_app_callout',
  CommunityMemberSettingsMobileApp: 'community_member_settings_mobile_app',
  CommunityMemberProfile: 'community_member_profile',
  CommunityPostFollowAuthorButton: 'community_post_follow_author_button',
  CommunityMemberDirectory: 'community_member_directory',
  CommunityPostForm: 'community_post_form',
  CommunityPostCommentForm: 'community_post_comment_form',
  CommunityPostReactionButton: 'community_post_reaction_button',
  CommunityOnboardingWizard: 'community_onboarding_wizard',
  CommunityProfileSettings: 'community_profile_settings',
  CommunityMemberSettings: 'community_member_settings',
  CommunityRequiredProfileSetup: 'community_required_profile_setup',
  CommunityAppInstallObservation: 'community_app_install_observation',
  CommunityAppPushPrompt: 'community_app_push_prompt',
  CommunityAppSettings: 'community_app_settings',
  CommunityAppBackgroundObservation: 'community_app_background_observation',
  CommunityAppLogout: 'community_app_logout',
  CommunityAppDeliveryCleanup: 'community_app_delivery_cleanup',
} as const;

export type NectarPageBlock = (typeof NectarPageBlock)[keyof typeof NectarPageBlock];
